import { get } from 'vuex-pathify';
export default {
  data: () => ({
    isBillingWaterUsageAnalysisLoaded: false,
    isBillingWaterUsageAnalysisVisible: false,
    maxFeatures: 20,
  }),
  computed: {
    waterMetersDataSourceName: get('admin/modulesMapping@billing.watermeters_datasource_name'),
    isBillingModuleEnabled: get('admin/additionalModules@BILLINGS.enabled'),
    isBillingSettingEnabled: get('admin/settingsValues@billings_module_enabled'),
    billingsWaterUsageAnalysisEnabled: get('admin/settingsValues@billings_water_usage_analysis_enabled'),
    isBillingWaterUsageAnalysisButtonVisible() {
      return this.currentLayer?.data_source_name === this.waterMetersDataSourceName;
    },
    isBillingWaterUsageAnalysisButtonDisabled() {
      return !this.isAnyFeatureSelected;
    },
    billingWaterUsageAnalysisButton() {
      return this.isBillingModuleEnabled &&
        this.isBillingSettingEnabled &&
        this.billingsWaterUsageAnalysisEnabled &&
        this.isBillingWaterUsageAnalysisButtonVisible
        ? [
            {
              name: 'billingWaterUsageAnalysis',
              disabled: this.isBillingWaterUsageAnalysisButtonDisabled,
              ...(this.isBillingWaterUsageAnalysisButtonDisabled && {
                tooltip: this.$i18n.t('dialog.billingWaterUsageAnalysis.selectAtLeastOneFeature'),
              }),
            },
          ]
        : [];
    },
  },
  methods: {
    billingWaterUsageAnalysisAction() {
      this.isBillingWaterUsageAnalysisLoaded = true;
      this.isBillingWaterUsageAnalysisVisible = true;
    },
  },
};
